import { useQuery } from 'react-query'

import { fetchCustomers } from '~shared-components/api/customers'
import { QueryCacheKey } from '~shared-components/utils/enums'
interface UseCustomersParameters {
  customerContextIds?: string[]
  customerName?: string
  customerNumbers?: string[]
  isEnabled?: boolean
  salesGroupIds?: string[]
}

export const useCustomers = ({
  customerContextIds,
  customerName,
  customerNumbers,
  isEnabled = true,
  salesGroupIds,
}: UseCustomersParameters) => {
  const queryCacheKey = [
    QueryCacheKey.Customers,
    {
      customerContextIds,
      customerName,
      customerNumbers,
      salesGroupIds,
    },
  ]

  const queryOptions = {
    enabled: Boolean(
      isEnabled &&
        (customerContextIds?.length || customerName || customerNumbers?.length),
    ),
  }
  const queryFunction = () =>
    fetchCustomers({
      filters: {
        customerContextIds,
        customerName,
        customerNumbers,
      },
      salesGroupIds,
    })

  return useQuery(queryCacheKey, queryFunction, queryOptions)
}
